import type { ReactNode } from "react";
export type Tone = "success" | "warning" | "danger" | "info" | "secondary";
export const StatusBadge = ({ tone, children }: { tone: Tone; children: ReactNode }) => (
  <span className={`badge badge-${tone} text-bg-${tone}`}>{children}</span>
);
